import {ReactAppBlock} from "@ok/core/engine/app-block/ReactAppBlock";
import {TPersistedStoreType} from "@ok/core/engine/app-block/IAppStore";
import {Logger} from "../logger/Logger";
import {AppController} from "./AppController";
import {IAppStore} from "./AppStore";

export class AppBlock<
    TAttrs,
    TAppAPI,
    TStore extends IAppStore<TPersistedStore>,
    TCtrl extends AppController<TStore>,
    TPersistedStore extends TPersistedStoreType = undefined
> extends ReactAppBlock<TAttrs, TAppAPI, TStore, TCtrl, TPersistedStore> {
    protected _getLogger() {
        return Logger;
    }
}
